import styled from 'styled-components'
import { LinkButton } from '@/components/common/buttons'
import FlatIcon from '@/components/common/icons/FlatIcon'
import { CartItemCountCircle } from '@/components/domains/etc'
import { FitpetMallEventEnum } from '@/constants/fitpet-mall-event.enum'
import { IconNameEnum } from '@/constants/icon-name.enum'
import { IconSizeEnum } from '@/constants/icon-size.enum'
import { FIXED_HEIGHT, SCREEN_MEDIA_QUERY, Z_INDEXES } from '@/constants/legacy/constLayout'
import ROUTES from '@/constants/legacy/constRoutes'
import { QueryStringKeyEnum } from '@/constants/query-string-key.enum'
import { useTracker } from '@/containers/contexts/EventTrackingProvider'
import { useCustomRouter, usePetType } from '@/containers/hooks'

interface ListHeaderProps {
  title?: string
}

export const ListHeader = ({ title }: ListHeaderProps) => {
  const tracker = useTracker()
  const { query } = useCustomRouter()
  const { getPetType } = usePetType()

  return (
    <StyledHeader>
      <div id="header-above-nav">
        <StyledContainer>
          <LeftContainer>
            <LinkButton goBack>
              <FlatIcon type={IconNameEnum.IcBack} size={IconSizeEnum.Size24} />
            </LinkButton>
          </LeftContainer>

          <HeaderTitle>{title || ''}</HeaderTitle>
          <RightContainer>
            <LinkButton
              rel="nosublink"
              url={{
                pathname: ROUTES.SEARCH,
                query: {
                  [QueryStringKeyEnum.SearchPetType]: query?.[QueryStringKeyEnum.SearchPetType] || getPetType(),
                },
              }}
              onClick={() => {
                tracker.triggerCustomEvent(FitpetMallEventEnum.ClickGnbSearchIcon)
              }}
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <FlatIcon type={IconNameEnum.IcSearch} size={IconSizeEnum.Size24} />
            </LinkButton>
            <LinkButton
              rel="nosublink"
              url={ROUTES.CART}
              onClick={() => {
                tracker.triggerCustomEvent(FitpetMallEventEnum.ClickGnbCartIcon)
              }}
              style={{ display: 'flex', alignItems: 'center', position: 'relative' }}
            >
              <CartItemCountCircle />
              <FlatIcon type={IconNameEnum.IcCart} size={IconSizeEnum.Size24} />
            </LinkButton>
          </RightContainer>
        </StyledContainer>
      </div>
    </StyledHeader>
  )
}

const StyledHeader = styled.div`
  z-index: ${Z_INDEXES.HEADER};
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  box-sizing: border-box;
  width: 100%;
  max-width: 576px;
  background-color: ${({
    theme: {
      color: { grayWhite },
    },
  }) => grayWhite};
  transition: transform 0.2s;
  -webkit-transition: transform 0.2s;
`

const StyledContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: ${FIXED_HEIGHT.HEADER / 10}rem;
  padding: 1.6rem;
`

const HeaderTitle = styled.h1`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  word-break: break-all;
  text-align: center;
  margin: auto;
  color: ${(props) => props.theme.color.gray900};
  font-weight: bold;
  font-size: 1.8rem;

  @media ${SCREEN_MEDIA_QUERY.xs} {
    font-size: 1.6rem;
  }
`

const LeftContainer = styled.div`
  width: 6.4rem;
`

const RightContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
`
